import { createSlice } from '@reduxjs/toolkit';

import { name, uploadUserSummaryAsync } from './thunks';
import { UserSummariesState } from './types';

const initialState: UserSummariesState = {
  uploadUserSummary: { status: 'idle' },
};

export const slice = createSlice({
  name,
  initialState,
  reducers: {
    clear: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(uploadUserSummaryAsync.pending, (state) => {
        state.uploadUserSummary.status = 'loading';
      })
      .addCase(uploadUserSummaryAsync.fulfilled, (state) => {
        state.uploadUserSummary.status = 'idle';
      })
      .addCase(uploadUserSummaryAsync.rejected, (state) => {
        state.uploadUserSummary.status = 'failed';
      });
  },
});

export const actions = slice.actions;

export default slice.reducer;
